import React, { Component } from "react";
import axios from "axios";
import WarrantModalDelete from "./WarrantModalDelete";
import WarrantModalEdit from "./WarrantModalEdit";

class WarrantNoList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            limit: 15,
            pageCount: 1,
            year: -1,
            warrantNos: [],
            search: "",
            modalOpen: false,
            modalType: "",
            modalInfo: {}
        };
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearchClear = this.handleSearchClear.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleLimitChange = this.handleLimitChange.bind(this);
        this.getRecords = this.getRecords.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalAndRefresh = this.closeModalAndRefresh.bind(this);
    }
    componentDidMount() {
        this.getRecords();
    }
    componentDidUpdate(prevProps) {
        if (this.props.filter !== prevProps.filter) {
            this.getRecords();
        }
    }
    handlePageChange(event) {
        this.setState({ page: parseInt(event.target.value) });
    }
    handleLimitChange(event) {
        const currentItem = ((this.state.page - 1) * this.state.limit) + 1;
        const pageCount = Math.ceil(this.state.warrantNos.length / event.target.value);
        const page = Math.ceil(currentItem / event.target.value);
        this.setState({ limit: event.target.value, page, pageCount });
    }
    handleYearChange(event) {
        //Not in use
        this.setState({ year: parseInt(event.target.value) });
        this.getRecords();
    }
    handleSearchChange(event) {
        this.setState({
            search: event.target.value
        });
    }
    handleSearchClear() {
        this.setState({
            search: ""
        });
        this.getRecords();
    }
    handleSearch() {
        const endpoint = "/getAllNumbers?year=0";
        axios.post(endpoint).then(results => {
            const filteredResults = results.data.filter(recordObject => {
                let include = false;
                for (const property in recordObject) {
                    if (recordObject[property]._ && typeof recordObject[property]._ == "string") {
                        if (recordObject[property]._.toLowerCase().includes(this.state.search.toLowerCase())) {
                            include = true;
                        }
                    }
                }

                return include;
            })
            const pageCount = Math.ceil(filteredResults.length / this.state.limit);
            this.setState({ warrantNos: filteredResults, page: 1, limit: 15, year: 0, pageCount });
        })
    }
    getRecords(event) {
        let year = event ? parseInt(event.target.value) : this.state.year;
        let yearModifier = "?year=";
        if (year === -1) {
            year = new Date().getFullYear();
        }
        yearModifier += year;
        const endpoint = this.props.filter === "user" ? "/getMyNumbers" + yearModifier : "/getAllNumbers" + yearModifier;
        axios.post(endpoint).then(results => {
            const pageCount = Math.ceil(results.data.length / this.state.limit);
            this.setState({ warrantNos: results.data, page: 1, limit: 15, search: "", pageCount, year });
        })
    }
    openModal(modalType, modalInfo) {
        this.setState({ modalOpen: true, modalType, modalInfo });
    }
    closeModal() {
        this.setState({ modalOpen: false, modalType: "", modalInfo: {} });
    }
    closeModalAndRefresh() {
        this.closeModal();
        this.getRecords();
    }
    makeTable() {
        const tableCells = [];
        const start = (this.state.page - 1) * this.state.limit;
        const remaining = this.state.warrantNos.length - start;
        const limit = Math.min(this.state.warrantNos.length, this.state.limit, remaining);
        const rowClassName = this.props.filter === "user" ? "warrantNoList__row" : "";
        for (let i = start; i < (start + limit); i++) {
            let current = this.state.warrantNos[i];
            let warrantNo = current.warrantNo._;
            if (warrantNo && warrantNo.startsWith("*")) {
                warrantNo = warrantNo.substr(1);
            }
            tableCells.push(
                <tr key={"WarrantNoResult" + i} className={rowClassName}>
                    <td className="warrantNoList__cell">{warrantNo}</td>
                    <td className="warrantNoList__cell">{current.detectiveName._}</td>
                    <td className="warrantNoList__cell warrantNoList__cell--Small">{current.agency._}</td>
                    <td className="warrantNoList__cell warrantNoList__cell--Small">{current.paoUnit._}</td>
                    <td className="warrantNoList__cell">{current.caseNumber._}</td>
                    <td className="warrantNoList__cell">{current.isSealed._ ? "Yes" : "No"}</td>
                    <td className="warrantNoList__cell">{current.approvingDPA._}</td>
                    <td className="warrantNoList__cell">{current.RowKey._}</td>
                </tr>
            );
            if (this.props.filter === "all") {
                let datePulled = new Date(current.Timestamp._);
                datePulled = datePulled.toString();
                tableCells.push(
                    <tr key={"WarrantNoResultDetail" + i} className="warrantNoList__row">
                        <td colSpan="7"  className="warrantNoList__cell--detail">
                            Date recorded: {datePulled}
                        </td>
                        <td className="warrantNoList__cell--detail">
                            <button 
                                className="warrantNoList__cell--editButton"
                                onClick={() => this.openModal("edit", current)}>
                                    Edit this record
                            </button>
                            <button 
                                className="warrantNoList__cell--deleteButton"
                                onClick={() => this.openModal("delete", current)}>
                                    Delete this record
                            </button>
                        </td>
                    </tr>
                )
            }
        }
        return tableCells;
    }
    paginator() {
        let selectDOM = [];
        for (let i = 1; i <= this.state.pageCount; i++) {
            selectDOM.push(
                <option value={i} key={"pageSelector" + i}>{i}</option>
            )
        }
        return selectDOM;
    }
    yearOptions() {
        let selectDOM = [<option value="0" key={"yearSelector-1"}>All</option>];
        let currentYear = new Date().getFullYear();
        for (let i = currentYear; i >= 2019; i--) {
            selectDOM.push(
                <option value={i} key={"yearSelector" + i}>{i}</option>
            )
        }
        return selectDOM;
    }
    render() {
        let tableCells = [];
        let pageDD = <option value="1">1</option>;
        let yearDD = this.yearOptions();
        let count = (this.state.page - 1) * this.state.limit + 1;
        let pageRecordCount = 0;
        const endpoint = this.props.filter === "user" ? "All King County Superior Court Felony Search Warrant Numbers you have generated" : "All search warrant numbers recorded";
        const modal = this.state.modalOpen === false ? (
            ""
        ) : this.state.modalType === "edit" ? (
            <WarrantModalEdit 
                closeModal={this.closeModal}
                closeModalAndRefresh={this.closeModalAndRefresh}
                recordInfo={this.state.modalInfo}
            />
        ) : (
            <WarrantModalDelete 
                closeModal={this.closeModal}
                closeModalAndRefresh={this.closeModalAndRefresh}
                recordInfo={this.state.modalInfo}
            />
        )
        const searchBar =
            this.props.filter === "user" ? (
                ""
            ) : (
                    <div className="warrantNoList__searchContainer">
                        <label className="warrantNoList__label" htmlFor="warrantNoList__search">Search for: </label>
                        <input 
                            type="text" 
                            name="warrantNoList__search" 
                            className="warrantNoList__search" 
                            placeholder="SW 20-0-00000-0" 
                            value={this.state.search} 
                            onChange={this.handleSearchChange}
                        />
                        <button 
                            type="button" 
                            className="warrantNoList__searchButton warrantNoList__searchButton--left"
                            onClick={this.handleSearch}>
                                Search
                        </button>
                        <button 
                            type="button" 
                            className="warrantNoList__searchButton warrantNoList__searchButton--right" 
                            onClick={this.handleSearchClear}>
                                Clear
                        </button>
                    </div>
                );
        if (this.state.warrantNos.length > 0) {
            tableCells = this.makeTable();
            pageDD = this.paginator();
            pageRecordCount = this.props.filter === "user" ? count + tableCells.length - 1 : count + (tableCells.length / 2) - 1;
        }
        return (
            <div className="warrantNoList">
                {modal}
                <div className="warrantNoList__header">
                    <span>{endpoint}</span>
                    {searchBar}
                </div>
                <table className="warrantNoList__table">
                    <thead>
                        <tr>
                            <th>Warrant No.</th>
                            <th>Detective's Name</th>
                            <th>Agency</th>
                            <th>PAO Unit</th>
                            <th>Case No.</th>
                            <th>Sealed</th>
                            <th>Approving DPA</th>
                            <th>Creator</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableCells}
                    </tbody>
                </table>
                <div className="warrantNoList__pagination">
                    <p>Showing <b>{tableCells.length === 0 ? 0 : count}-{pageRecordCount}</b> of <b>{this.state.warrantNos.length}</b></p>
                    <div className="warrantNoList__pageControls">
                        <label>Year:&nbsp;
                            <select value={this.state.year} onChange={this.getRecords}>
                                {yearDD}
                            </select>
                        </label>
                        <label>Page:&nbsp;
                            <select value={this.state.page} onChange={this.handlePageChange}>
                                {pageDD}
                            </select>
                        </label>
                        <label>Records per page:&nbsp;
                            <select value={this.state.limit} onChange={this.handleLimitChange}>
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </label>
                        <div className="warrantNoList__pageStepControls">
                            <button type="button" value="1" onClick={this.handlePageChange} className="warrantNoList__pageStepControls--first">First</button>
                            <button type="button" value={this.state.page - 1} onClick={this.handlePageChange} disabled={this.state.page === 1 ? true : false}>Previous</button>
                            <button type="button" value={this.state.page + 1} onClick={this.handlePageChange} disabled={this.state.page === this.state.pageCount || this.state.pageCount === 0 ? true : false}>Next</button>
                            <button type="button" value={this.state.pageCount} onClick={this.handlePageChange} className="warrantNoList__pageStepControls--last">Last</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WarrantNoList;